import React, { useState } from "react";
import { BaseUrl } from "../../../constants/BaseURL";

export default function EmbeddedTimetableSettings({ id }) {

  // clean white + grey + primary blue defaults
  const [buttonColour, setButtonColour] = useState("#0d6efd"); // primary border
  const [buttonTextColour, setButtonTextColour] = useState("#ffffff");
  const [buttonBackgroundColour, setButtonBackgroundColour] = useState("#0d6efd");
  const [buttonHoverBackgroundColour, setButtonHoverBackgroundColour] = useState("#0b5ed7");
  const [buttonHoverTextColour, setButtonHoverTextColour] = useState("#ffffff");
  const [buttonShape, setButtonShape] = useState("rounded");
  const [buttonStyle, setButtonStyle] = useState("solid");

  const [tableHeaderColour, setTableHeaderColour] = useState("#ffffff");
  const [tableBodyColour, setTableBodyColour] = useState("#ffffff");
  const [tableBorderColour, setTableBorderColour] = useState("#cccccc");

  const [innerBoxBorderColour, setInnerBoxBorderColour] = useState("#cccccc");
  const [innerBoxBackgroundColour, setInnerBoxBackgroundColour] = useState("#ffffff");

  const [dayFontColour, setDayFontColour] = useState("#000000");
  const [dateFontColour, setDateFontColour] = useState("#333333");

  const [font, setFont] = useState("Poppins");
  const [corners, setCorners] = useState("rounded");
  const [textColour, setTextColour] = useState("#000000");
  const [backgroundColour, setBackgroundColour] = useState("#ffffff");
  const [timeFormat, setTimeFormat] = useState("12-hour");

  const iframeUrl = `${BaseUrl}/WidgitTimetable/${id}?buttonColour=${encodeURIComponent(
    buttonColour
  )}&buttonTextColour=${encodeURIComponent(
    buttonTextColour
  )}&buttonBackgroundColour=${encodeURIComponent(
    buttonBackgroundColour
  )}&buttonHoverBackgroundColour=${encodeURIComponent(
    buttonHoverBackgroundColour
  )}&buttonHoverTextColour=${encodeURIComponent(
    buttonHoverTextColour
  )}&buttonShape=${encodeURIComponent(
    buttonShape
  )}&buttonStyle=${encodeURIComponent(
    buttonStyle
  )}&tableHeaderColour=${encodeURIComponent(
    tableHeaderColour
  )}&tableBodyColour=${encodeURIComponent(
    tableBodyColour
  )}&tableBorderColour=${encodeURIComponent(
    tableBorderColour
  )}&innerBoxBorderColour=${encodeURIComponent(
    innerBoxBorderColour
  )}&innerBoxBackgroundColour=${encodeURIComponent(
    innerBoxBackgroundColour
  )}&dayFontColour=${encodeURIComponent(
    dayFontColour
  )}&dateFontColour=${encodeURIComponent(
    dateFontColour
  )}&font=${encodeURIComponent(
    font
  )}&corners=${encodeURIComponent(
    corners
  )}&textColour=${encodeURIComponent(
    textColour
  )}&backgroundColour=${encodeURIComponent(
    backgroundColour
  )}&timeFormat=${encodeURIComponent(timeFormat)}`;

  const embedCode = `<iframe src="${iframeUrl}" width="100%" height="570" frameborder="0" allowfullscreen loading="lazy"></iframe>`;
  const roundedClass = corners === "rounded" ? "rounded-4" : "";

  return (
    <div className="p-3">
      <h4 className="mb-3">Embedded Timetable Settings</h4>

      <div className="row g-4">

        {/* --- TABLE SETTINGS --- */}
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Table Settings</h5>
              <div className="row g-3">

                <div className="col-sm-4">
                  <label className="form-label">Table Header Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={tableHeaderColour}
                    onChange={(e) => setTableHeaderColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Table Body Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={tableBodyColour}
                    onChange={(e) => setTableBodyColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Table Border Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={tableBorderColour}
                    onChange={(e) => setTableBorderColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Inner Box Border Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={innerBoxBorderColour}
                    onChange={(e) => setInnerBoxBorderColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Inner Box Background Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={innerBoxBackgroundColour}
                    onChange={(e) => setInnerBoxBackgroundColour(e.target.value)} />
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* --- BUTTON SETTINGS --- */}
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Button Settings</h5>
              <div className="row g-3">

                <div className="col-sm-4">
                  <label className="form-label">Button Border Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={buttonColour}
                    onChange={(e) => setButtonColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Button Text Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={buttonTextColour}
                    onChange={(e) => setButtonTextColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Button Background Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={buttonBackgroundColour}
                    onChange={(e) => setButtonBackgroundColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Button Hover Background Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={buttonHoverBackgroundColour}
                    onChange={(e) => setButtonHoverBackgroundColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Button Hover Text Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={buttonHoverTextColour}
                    onChange={(e) => setButtonHoverTextColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Button Shape</label>
                  <select className="form-select"
                    value={buttonShape}
                    onChange={(e) => setButtonShape(e.target.value)}>
                    <option value="square">Square</option>
                    <option value="rounded">Rounded</option>
                  </select>
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Button Style</label>
                  <select className="form-select"
                    value={buttonStyle}
                    onChange={(e) => setButtonStyle(e.target.value)}>
                    <option value="outline">Outline</option>
                    <option value="solid">Solid</option>
                  </select>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* --- FONT + STYLE --- */}
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Font and Style</h5>
              <div className="row g-3">

                <div className="col-sm-4">
                  <label className="form-label">Day Font Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={dayFontColour}
                    onChange={(e) => setDayFontColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Date Font Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={dateFontColour}
                    onChange={(e) => setDateFontColour(e.target.value)} />
                </div>

                <div className="col-sm-4">
                  <label className="form-label">Text Colour</label>
                  <input type="color" className="form-control form-control-color"
                    value={textColour}
                    onChange={(e) => setTextColour(e.target.value)} />
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Background Colour</label>
                  <input type="color"
                    className="form-control form-control-color"
                    value={backgroundColour === "transparent" ? "#ffffff" : backgroundColour}
                    onChange={(e) => setBackgroundColour(e.target.value)}
                    disabled={backgroundColour === "transparent"} />
                  <div className="form-check mt-2">
                    <input className="form-check-input" type="checkbox"
                      checked={backgroundColour === "transparent"}
                      onChange={(e) =>
                        setBackgroundColour(e.target.checked ? "transparent" : "#ffffff")
                      }
                    />
                    <label className="form-check-label">Transparent Background</label>
                  </div>
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Font</label>
                  <select className="form-select"
                    value={font}
                    onChange={(e) => setFont(e.target.value)}>
                    <option value="Inter">Inter</option>
                    <option value="Arial">Arial</option>
                    <option value="Roboto">Roboto</option>
                    <option value="Poppins">Poppins</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Lato">Lato</option>
                    <option value="Open Sans">Open Sans</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Nunito">Nunito</option>
                    <option value="Merriweather">Merriweather</option>
                  </select>
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Corner Style</label>
                  <select className="form-select"
                    value={corners}
                    onChange={(e) => setCorners(e.target.value)}>
                    <option value="square">Square</option>
                    <option value="rounded">Rounded</option>
                  </select>
                </div>

                <div className="col-sm-6">
                  <label className="form-label">Time Format</label>
                  <select className="form-select"
                    value={timeFormat}
                    onChange={(e) => setTimeFormat(e.target.value)}>
                    <option value="12-hour">12 hour</option>
                    <option value="24-hour">24 hour</option>
                  </select>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/* --- PREVIEW --- */}
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Live Preview</h5>
              <div className={`p-2 border ${roundedClass}`}>
                <iframe
                  src={iframeUrl}
                  className="w-100"
                  height={570}
                  loading="lazy"
                  title="timetable"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>

        {/* --- EMBED CODE --- */}
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-2">Embed Code</h5>
              <p className="text-muted small mb-2">Copy and paste this into your site.</p>
              <textarea className="form-control" rows={4} readOnly value={embedCode} />
              <div className="d-flex justify-content-end mt-2">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigator.clipboard.writeText(embedCode)}
                >
                  Copy Code
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
